import { createFileRoute, Outlet } from "@tanstack/react-router";
import { HrdAccessStatusAlert } from "@/components/hrd/HrdAccessStatusAlert";
import { useAppSelector } from "@/store/hooks";
import { Stack } from "@mui/material";

export const Route = createFileRoute("/_dashboard/hrd")({
  component: HrdLayout,
});

function HrdLayout() {
  const user = useAppSelector((state) => state.auth.user);

  return (
    <Stack gap={2}>
      <HrdAccessStatusAlert status={user!.hrdAccessStatus} />
      <Outlet />
    </Stack>
  );
}
